module.exports = __webpack_public_path__ + "img/Ölschadenbekämpfung.546064a8.svg";